import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initASwap } from './aswap'
import { initScrollDown } from './shared/scroll-down';
import { initPrintMe } from './shared/print';
import { initHistoryLoadMore } from './shared/history';
import { initAjaxedSearch } from './shared/search';
import { initCookies } from './shared/cookies';
import { initClipboard } from './shared/clipboard';

WCAG.init()
initCommon()
initASwap()
initScrollDown()
initPrintMe()
initHistoryLoadMore()
initAjaxedSearch()
initCookies()
initClipboard()